exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.nav-toolbar {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: row nowrap;\r\n          flex-flow: row nowrap;\r\n  -webkit-box-pack: justify;\r\n      -ms-flex-pack: justify;\r\n          justify-content: space-between;\r\n}\r\n\r\n.nav-toolbar__item {\r\n    color: rgba(255, 255, 255, 0.35);\r\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\r\n}\r\n\r\n.nav-toolbar__item.active md-icon {\r\n    width: 36px;\r\n    height: 36px;\r\n    line-height: 36px;\r\n    font-size: 36px;\r\n}\r\n\r\n.active {\r\n    color: rgb(149, 117, 205);\r\n}\r\n\r\n.new-message-hint {\r\n  display: block;\r\n  width: 6px;\r\n  height: 6px;\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 10px;\r\n  background-color: #FF0000;\r\n  border-radius: 50%;\r\n}\r\n\r\n.active .new-message-hint {\r\n  top: 8px;\r\n  right: 8px;\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-main-navigation/toolbar-main-navigation.component.css
// module id = ../../../../../src/app/toolbar/toolbar-main-navigation/toolbar-main-navigation.component.css
// module chunks = 4